import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import { providePrimeNG } from 'primeng/config';

import { appRoutes } from './app.routes';
import { GlobalErrorHandler } from './core/error-handler';
import { LeasityAuraPreset } from './core/theme/leasity-aura-preset';
import { httpCorrelationInterceptor } from './core/interceptors/http-correlation.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideHttpClient(withFetch(), withInterceptors([httpCorrelationInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: { preset: LeasityAuraPreset, options: { darkModeSelector: '.app-dark' } },
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
